import React, { useEffect, useState } from "react";
import {
  endInteraction,
  setcontactlist,
  setExternalChatData,
  updateStatus,
  UpdateExternalContactList,
} from "../../../../Redux/Actions/actions";
import { connect } from "react-redux";
import axios from "axios";
import { BaseUrl } from "../../../../Container/BaseUrl/BaseUrl";
import { toast } from "react-toastify";
import {
  DialogTitle,
  DialogContentText,
  DialogContent,
  DialogActions,
  Dialog,
  Stack,
  Button,
  Typography,
} from "@mui/material";
import { useTimer } from "react-timer-hook";
import { toaststyle } from "../../../../Utils/toaststyle";
import {
  end_call,
  useCompleted,
  useCompletedCampaign,
} from "../../../Utils/Call-utils/call-utils";

const mapStateToProps = (state) => {
  return {
    chatid: state.data.chatid,
    chat: state.data.chat,
    externalChatData: state.contactListData.externalChatData,
    readyButton: state.contactListData.readyButton,
    showingStatus: state.contactListData.showingStatus,
    showingStatusClass: state.contactListData.showingStatusClass,
    showingStatusVoice: state.contactListData.showingStatusVoice,
  };
};

const EndchatModelForPopCall = (props) => {
  const selectedChat = JSON.parse(localStorage.getItem("client"));
  const userId = JSON.parse(localStorage.getItem("tokenAgent"));
  const completed = useCompleted();
  const completedCampaign = useCompletedCampaign();
  const { OpenDialog, handleClose } = props;
  const [reasonerror, setreasonerror] = useState(false);
  const [comments, setComments] = useState("");
  const [reason, setReason] = useState("");
  const [dispositionlist, setdispositionlist] = useState([]);
  const time = new Date();
  time.setSeconds(time.getSeconds() + 15);
  const submitEndChat = (endReason, endComment) => {
    try {
      const agentId = userId.id;
      const contactType = localStorage.getItem("type");
      const isContactVoice =
        contactType === "sales" || contactType === "service";
      const data = {
        chat_session_id: selectedChat?.chat_session_id,
        chatendby: "Agent",
        reason: endReason,
        comment: endComment,
        agent_id: agentId,
        ...(isContactVoice
          ? {
              contact_id: localStorage.getItem("ContactVoiceId"),
              voice_type: "contact_voice",
              contact_type: contactType,
            }
          : { ticket: false }),
      };
      axios
        .post(BaseUrl + "/message/endchat", data, {
          headers: {
            tenantId: localStorage.getItem("TenantId"),
          },
        })
        .then(async (res) => {
          if (res.data.success) {
            end_call();
            const agentStatus = localStorage.getItem("AgentStatus");
            if (!["Outbound"].includes(agentStatus)) {
              props.updateStatus("Ready");
            }
            localStorage.removeItem("callActivate");
            localStorage.removeItem("type");
            localStorage.removeItem("ContactVoiceId");
            localStorage.removeItem("Contactreg_no");
            switch (selectedChat?.direction) {
              case "CM_Outbound":
                completedCampaign(endReason);
                break;
              case "MC_Outbound":
                completed(endReason);
                break;
              default:
                props.UpdateExternalContactList(
                  JSON.parse(localStorage.getItem("client")).chat_session_id,
                );
                break;
            }
            toast.success("Interaction Ended Successfully", toaststyle);
            handleClose();
          } else {
            toast.error(
              "Failed to end interaction. Please try again.",
              toaststyle,
            );
            handleClose();
            props.setExternalChatData(null);
          }
        })
        .catch((error) => {
          toast.error(
            "Unable to reach server. Please check your connection.",
            toaststyle,
          );
          handleClose();
          props.setExternalChatData(null);
        });
    } catch (error) {
      toast.error(
        "An unexpected error occurred. Please try again.",
        toaststyle,
      );
      handleClose();
      props.setExternalChatData(null);
    }
  };
  const { seconds, minutes, start } = useTimer({
    expiryTimestamp: time,
    onExpire: () => {
      const isContactType =
        localStorage.getItem("type") === "sales" ||
        localStorage.getItem("type") === "service";
      submitEndChat(
        isContactType ? reason : "NoDisposition",
        isContactType ? comments : "Completed",
      );
    },
  });
  const endChat = () => {
    if (reason === "") {
      setreasonerror(true);
    } else {
      submitEndChat(reason, comments);
    }
  };
  const Dispositionlist = async () => {
    axios
      .post(
        BaseUrl + "/userstatus/dispositionlist",
        {},
        {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("access_token"),
            "Content-Type": "application/json",
            tenantId: localStorage.getItem("TenantId"),
          },
        },
      )
      .then((res) => {
        if (res.data.status) {
          setdispositionlist(res.data.data);
        } else {
          setdispositionlist([]);
        }
      })
      .catch((err) => {});
  };

  useEffect(() => {
    if (dispositionlist.length > 0) {
      setReason(
        dispositionlist[0].dispositionName || dispositionlist.dispositionName,
      );
    }
    start();
  }, []);

  return (
    <Dialog
      open={OpenDialog}
      keepMounted
      onClose={() => {
        if (
          localStorage.getItem("TenantId") ===
          "afb31819-2128-4d23-9bae-2ff09c53246f"
        ) {
          return;
        } else {
          handleClose();
        }
      }}
      aria-describedby="alert-dialog-slide-description"
      maxWidth="sm"
      fullWidth
    >
      <DialogTitle
        variant="subtitle2"
        sx={{
          fontSize: "16px",
          fontWeight: 600,
          boxShadow:
            "rgba(50, 50, 93, 0.25) 0px 2px 5px -1px, rgba(0, 0, 0, 0.3) 0px 1px 3px -1px",
        }}
      >
        <Stack
          direction={"row"}
          sx={{ width: "100%" }}
          justifyContent={"space-between"}
        >
          <Typography sx={{ fontWeight: "600" }}>End Interaction</Typography>
          <Typography sx={{ fontWeight: "600" }}>
            {minutes >= 10 ? minutes : "0" + minutes}:
            {seconds >= 10 ? seconds : "0" + seconds}
          </Typography>
        </Stack>
      </DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-slide-description">
          <Stack
            className="mt-3"
            sx={{ display: "flex", justifyContent: "center" }}
          >
            <Stack className="fs-13 mb-3">
              <label
                htmlFor="exampleFormControlTextarea1"
                className="form-label fs-13"
              >
                Reason*
              </label>
              <select
                className={`form-select fs-13 ${reasonerror ? "is-invalid" : ""}`}
                aria-label="Default select example"
                onChange={(e) => {
                  setReason(e.target.value);
                }}
                onClick={Dispositionlist}
              >
                <option>Select Reason</option>
                {dispositionlist.length > 0 ? (
                  dispositionlist.map((item) => (
                    <option
                      value={item.dispositionName}
                      key={item.dispositionName}
                    >
                      {item.dispositionName}
                    </option>
                  ))
                ) : (
                  <></>
                )}
              </select>
            </Stack>
            {reasonerror ? (
              <span className="text-danger">Choose a reason*</span>
            ) : null}
            <div className="mb-3">
              <label
                htmlFor="exampleFormControlTextarea1"
                className="form-label fs-13"
              >
                Comments
              </label>
              <textarea
                onChange={(e) => setComments(e.target.value)}
                style={{ height: "100px" }}
                className="form-control fs-13"
                id="exampleFormControlTextarea1"
                rows="3"
                onKeyDown={(event) => {
                  if (event.key === 13 || event.key === 13) {
                    event.preventDefault();
                    if (reason === "") {
                      setreasonerror(true);
                    } else {
                      endChat();
                    }
                  }
                }}
              ></textarea>
            </div>
          </Stack>
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button
          onClick={() => {
            if (reason === "") {
              setreasonerror(true);
            } else {
              endChat();
            }
          }}
          variant="contained"
          size="small"
          id="submit-btn"
        >
          SUBMIT
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default connect(mapStateToProps, {
  endInteraction,
  setcontactlist,
  setExternalChatData,
  updateStatus,
  UpdateExternalContactList,
})(EndchatModelForPopCall);
